// extracted by mini-css-extract-plugin
export default {"container":"LoadingSkeleton_container__4s59o","skeleton":"LoadingSkeleton_skeleton__en+pO","skeleton-loading":"LoadingSkeleton_skeleton-loading__EOxuA"};